module.exports = __webpack_public_path__ + "static/media/copy-text-icon.8a7764b0.svg";